import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Estado das bandeiras que governam itens do menu — numa consulta só.
 *
 * `useFeatureFlag` lê UMA bandeira por chamada, e um hook não pode ser chamado dentro de
 * um laço de itens. Aqui as chaves de todos os itens do menu vão juntas.
 *
 * Falha FECHADA: enquanto a consulta corre, ou se ela falhar, o objeto vem vazio e o item
 * fica escondido. Item de menu que some por um instante é um incômodo; item de recurso
 * desligado que aparece por um instante leva a pessoa a uma tela que redireciona.
 */
export function useNavFlags(keys: readonly string[]): Record<string, boolean> {
  const ordenadas = [...new Set(keys)].sort();
  const { data } = useQuery({
    queryKey: ["nav-feature-flags", ordenadas.join(",")],
    enabled: ordenadas.length > 0,
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("feature_flags")
        .select("flag_key, enabled")
        .in("flag_key", ordenadas);
      if (error) throw error;
      return Object.fromEntries((data ?? []).map((f) => [f.flag_key, f.enabled === true]));
    },
  });
  return data ?? {};
}
